import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timeToEnd"
}

import { onMounted, onUnmounted, ref } from 'vue';
  import keycloak from '@/plugins/keycloak';

  interface TimeToEnd {
    total: number;
    minutes: number;
    seconds: number;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'TimeToEndSession',
  setup(__props) {

  const timeToEnd = ref<TimeToEnd | undefined>(calculateTimeToEnd());

  function calculateTimeToEnd(): TimeToEnd | undefined {
    let targetDate = undefined;
    if (keycloak && keycloak.idTokenParsed && keycloak.idTokenParsed.exp) {
      targetDate = new Date(keycloak.idTokenParsed.exp * 1000);
    }

    if (targetDate) {
      const total = targetDate?.getTime() - new Date().getTime();
      const seconds =
        Math.floor((total / 1000) % 60) < 10
          ? '0' + Math.floor((total / 1000) % 60)
          : Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      return {
        total,
        minutes,
        seconds,
      };
    } else {
      return undefined;
    }
  }

  let interval: number;
  onMounted(() => {
    interval = window.setInterval(() => {
      timeToEnd.value = calculateTimeToEnd();
    }, 1000);
  });

  onUnmounted(() => {
    clearInterval(interval);
  });

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (timeToEnd.value !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          variant: "plain",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(timeToEnd.value?.minutes) + ":" + _toDisplayString(timeToEnd.value?.seconds), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})